module.exports = __webpack_public_path__ + "img/pencil-sprite.68a21704.png";